export default function formAgnostic() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link($scope, $element, $attrs, $ctrl) {
      $ctrl.$pristine = false;
    },
  };
}
